import api from './api'

export const notificationService = {
  async getNotifications(clubUuid: string, page: number = 1, perPage: number = 50): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/notifications`, {
      params: { page, per_page: perPage }
    })
    return response.data
  },

  async getNotification(clubUuid: string, notificationId: string): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/notifications/${notificationId}`)
    return response.data
  },

  async getUnreadCount(clubUuid: string): Promise<number> {
    const response = await api.get(`v1/${clubUuid}/notifications/unread/count`)
    return response.data.unread_count
  },

  async markAsRead(clubUuid: string, notificationUuids: string[]): Promise<any> {
    const response = await api.post(`v1/${clubUuid}/notifications/mark-as-read`, {
      notification_uuids: notificationUuids
    })
    return response.data
  },

  async markAsUnread(clubUuid: string, notificationUuids: string[]): Promise<any> {
    const response = await api.post(`v1/${clubUuid}/notifications/mark-as-unread`, {
      notification_uuids: notificationUuids
    })
    return response.data
  }
}
